import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HelpCircle, ArrowUpRight } from "lucide-react";
import { fetchTrendingQuestions } from "../../lib/api";
import { SectionHeader } from "./SectionHeader";

export const TrendingQuestions = () => {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTrendingQuestions(6).then(setItems).catch(() => setItems([]));
  }, []);

  if (items && items.length === 0) return null;

  const onClick = (q) => navigate("/chat", { state: { initial: q.query } });

  return (
    <section data-testid="home-trending-questions" className="mt-12 sm:mt-16">
      <SectionHeader
        icon={HelpCircle}
        eyebrow="Buying questions"
        title="What people are asking this week"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {(items || Array.from({ length: 6 })).map((q, i) =>
          q ? (
            <button
              key={q.slug || q.query || i}
              onClick={() => onClick(q)}
              data-testid={`home-trending-${i}`}
              className="group flex items-center justify-between gap-3 text-left rounded-xl border border-border bg-card hover:bg-secondary/40 hover:border-emerald-500/40 px-4 py-3.5 transition"
            >
              <span className="text-sm text-foreground/90 group-hover:text-foreground font-medium leading-snug">
                {q.query}
              </span>
              <ArrowUpRight className="w-4 h-4 text-emerald-500/70 group-hover:text-emerald-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition shrink-0" />
            </button>
          ) : (
            <div
              key={i}
              className="h-14 rounded-xl bg-card border border-border animate-pulse"
            />
          ),
        )}
      </div>
    </section>
  );
};

export default TrendingQuestions;
